import React from 'react';

interface TimelinePhase {
  phase: string;
  duration: string;
  title: string;
  description: string;
  deliverables: string[];
}

interface ProgramTimelineProps {
  phases: TimelinePhase[];
}

const ProgramTimeline: React.FC<ProgramTimelineProps> = ({ phases }) => {
  return (
    <section className="py-12 sm:py-16 lg:py-24 bg-surface">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-text-primary mb-4 sm:mb-6">
              Program Timeline & Phases
            </h2>
            <p className="text-base sm:text-lg text-text-secondary max-w-3xl mx-auto leading-relaxed px-2">
              A systematic four-phase approach that ensures strategic clarity, leadership capability, and execution readiness throughout the engagement.
            </p>
          </div>

          <div className="space-y-6 sm:space-y-8">
            {phases.map((phase, index) => (
              <div
                key={index}
                className="bg-background rounded-lg institutional-border overflow-hidden hover:institutional-shadow transition-base"
              >
                <div className="flex flex-col sm:flex-row">
                  <div className="sm:w-1/4 bg-institutional p-5 sm:p-8">
                    <div className="text-xs sm:text-sm font-semibold uppercase tracking-wider mb-1 sm:mb-2 text-white opacity-80">
                      {phase.phase}
                    </div>
                    <div className="text-xl sm:text-2xl font-bold mb-1 sm:mb-2 text-white">{phase.title}</div>
                    <div className="text-xs sm:text-sm text-white opacity-80">{phase.duration}</div>
                  </div>
                  <div className="sm:w-3/4 p-5 sm:p-8">
                    <p className="text-sm sm:text-base text-text-secondary mb-4 sm:mb-6 leading-relaxed">
                      {phase.description}
                    </p>
                    <div>
                      <h4 className="text-xs sm:text-sm font-semibold text-text-primary uppercase tracking-wider mb-3 sm:mb-4">
                        Key Deliverables
                      </h4>
                      <ul className="space-y-2 sm:space-y-3">
                        {phase.deliverables.map((deliverable, idx) => (
                          <li key={idx} className="flex items-start">
                            <span className="w-1.5 h-1.5 bg-institutional rounded-full mt-1.5 sm:mt-2 mr-2 sm:mr-3 flex-shrink-0"></span>
                            <span className="text-xs sm:text-sm text-text-secondary">{deliverable}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProgramTimeline;